/* eslint-disable react/prop-types */
/* istanbul ignore file */
import React, { createContext, useContext, ReactNode } from "react";

interface ChapterContextType {
  startAttachments: () => void;
  setPrefix: (value: boolean) => void;
  getFormattedChapter: (depth: number, text: string) => string;
}

const ChapterContext = createContext<ChapterContextType | undefined>(undefined);

export const useChapter = (): ChapterContextType => {
  const context = useContext(ChapterContext);
  if (!context) {
    throw new Error("useChapter must be used within a ChapterProvider");
  }
  return context;
};

interface ChapterProviderProps {
  children: ReactNode;
}

export const ChapterProvider: React.FC<ChapterProviderProps> = ({
  children,
}) => {
  const baseCharValue = 64;
  let attachments = false;
  let prefix = true;

  let chapterCounter: number[] = new Array(10).fill(0);

  const getNextChapter = (level: number): string => {
    const index = level - 1;
    if (index < 0 || index >= chapterCounter.length) {
      throw new Error(`Invalid level: ${level}`);
    }

    chapterCounter[index]++;
    for (let i = index + 1; i < chapterCounter.length; i++) {
      chapterCounter[i] = 0;
    }
    const chapter = chapterCounter.slice(0, index + 1).join(".");

    if (attachments) {
      return `Bijlage ${String.fromCharCode(
        baseCharValue + chapterCounter[index]
      )}:`;
    }

    return chapter.toString();
  };

  const startAttachments = (): void => {
    attachments = true;
    chapterCounter = new Array(10).fill(0);
  };

  const setPrefix = (value: boolean): void => {
    prefix = value;
  };

  const getFormattedChapter = (level: number, text: string): string => {
    if (!prefix) return text;

    return getNextChapter(level) + " " + text;
  };

  return (
    <ChapterContext.Provider
      value={{
        startAttachments,
        setPrefix,
        getFormattedChapter,
      }}
    >
      {children}
    </ChapterContext.Provider>
  );
};
